import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsButtonModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { ExperimentalNgGridModule } from '../grid';

import { TableComponent } from './table.component';
import { TranslationIdMap } from './table.i18n';

@NgModule({
    declarations: [TableComponent],
    exports: [TableComponent],
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        ExperimentalNgGridModule,
    ],
})
export class CmpsMi2TableModule {}
